import React, { Fragment } from "react"
import { Link } from "gatsby"
import Box from "@material-ui/core/Box"
import { FiUser, FiMail, FiSettings, FiCheck, FiPower } from "react-icons/fi"
const AccountMenuItem = ({ linkProps, clickFun }) => {
  return (
    <Fragment>
      {linkProps.devider ? (
        <Box component="div" className="dropdown-divider"></Box>
      ) : (
        ""
      )}
      <Link className="dropdown-item" to={linkProps.path} onClick={clickFun}>
        <i className={linkProps.iClassName}>{linkProps.icon}</i>
        <Box component="span">{linkProps.text}</Box>
      </Link>
    </Fragment>
  )
}

export default AccountMenuItem
